export default "__VITE_ASSET__CNZhgrJP__"